module.exports = __webpack_public_path__ + "img/account-new-mt4.4c0f9e5f.png";